import React from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

const Paragraphe = ({value = '', onChange, disabled = false }) => {
  return (
    <TextArea
      placeholder="Paragraphe"
      disabled={disabled}
      autoSize={{ minRows: 3, maxRows: 6 }}
      style={{ width: '100%' }}
       value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
}; 

export default Paragraphe;
 